export enum AdminOnlinePaymentReportTabs {
    PaymentReport = 1,
    OnlinePaymentAccountSetup = 2,
    Lending = 3,
}
